import React, { useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import LicenseCard from "layouts/components/card/LicenseCard";
import data from "./data/licenseData";

function License() {
  const [open, setOpen] = useState(false); // 모달 상태
  const [selectedItem, setSelectedItem] = useState(null); // 모달에 표시할 항목
  const [alertOpen, setAlertOpen] = useState(false); // Alert 상태
  const [alertMessage, setAlertMessage] = useState(""); // Alert 메시지

  const handleOpen = (item) => {
    if (item.status) {
      setAlertMessage("해당 항목은 현재 준비 중입니다."); // Alert 메시지 설정
      setAlertOpen(true); // Alert 열기
      return;
    }
    setSelectedItem(item); // 선택된 항목 설정
    setOpen(true); // 모달 열기
  };

  const handleClose = () => {
    setOpen(false); // 모달 닫기
    setSelectedItem(null); // 선택된 항목 초기화
  };

  const handleAlertClose = () => {
    setAlertOpen(false); // Alert 닫기
  };

  const renderData = data.map(({ title, description, items }) => (
    <Grid container spacing={3} sx={{ mb: 10 }} key={title}>
      {/* 왼쪽 타이틀과 설명 */}
      <Grid
        item
        xs={12}
        sm={3} // 작은 화면에서는 100%, 태블릿 이상에서는 3:9 비율
        md={3}
        sx={{
          display: { xs: "block", sm: "block" }, // 작은 화면에서도 보이도록 유지
          textAlign: { xs: "center", md: "left" },
          padding: { xs: 1, sm: 2 },
        }}
      >
        <MKBox
          position="sticky"
          top="100px"
          pb={{ xs: 2, md: 6 }}
          sx={{
            textAlign: { xs: "center", md: "left" }, // 모바일에서는 중앙 정렬
            padding: { xs: 1, md: 2 },
          }}
        >
          <MKTypography
            variant="h3"
            fontWeight="bold"
            mb={1}
            sx={{
              fontSize: { xs: "1.25rem", sm: "1.5rem", md: "2rem" }, // 반응형 제목 크기
            }}
          >
            {title}
          </MKTypography>
          <MKTypography
            variant="body2"
            fontWeight="regular"
            color="secondary"
            mb={1}
            sx={{
              display: { xs: "none", sm: "block" }, // 모바일에서 숨김
              fontSize: { sm: "0.8rem", md: "1rem" },
            }}
          >
            {description}
          </MKTypography>
        </MKBox>
      </Grid>

      {/* 오른쪽 카드 영역 */}
      <Grid
        item
        xs={12}
        sm={9}
        md={9}
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: { xs: "center", sm: "flex-start" },
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            justifyContent: { sm: "flex-start" }, // 모바일에서는 중앙 정렬
          }}
        >
          {items.map((item) => (
            <Grid
              item
              xs={6} // 모바일에서 2열 배치
              sm={6} // 태블릿에서도 2열 유지
              md={4} // 데스크톱에서 3열
              key={item.name}
              sx={{
                mb: 3,
                height: { xs: "220px", sm: "300px", md: "400px" }, // 카드 높이 조정
              }}
            >
              <LicenseCard
                image={item.image}
                name={item.name}
                discription={item.discription}
                status={item.status}
                onCardClick={() => handleOpen(item)} // 모달 또는 Alert 트리거
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  ));

  return (
    <MKBox component="section" my={6} py={6}>
      <Container>
        <MKBox textAlign="center" my={{ xs: 4, sm: 6 }}>
          <MKTypography
            variant="h2"
            fontWeight="bold"
            sx={{
              fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" }, // 반응형 제목 크기
            }}
          >
            지식재산권 및 인증서
          </MKTypography>
          <MKTypography
            variant="body1"
            color="text"
            sx={{
              fontSize: { xs: "0.875rem", sm: "1rem", md: "1.125rem" }, // 반응형 텍스트 크기
            }}
          >
            JOHEUNBICH(좋은빛)
          </MKTypography>
        </MKBox>

        {renderData}
      </Container>

      {/* 모달 */}
      {selectedItem && (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogContent>
            <MKBox component="img" src={selectedItem.image} alt={selectedItem.name} width="100%" />
            <MKBox mt={2}>
              <MKTypography
                variant="h4"
                fontWeight="bold"
                sx={{
                  textAlign: "center", // 가운데 정렬
                }}
              >
                {selectedItem.name}
              </MKTypography>
              <MKTypography variant="body2">{selectedItem.discription}</MKTypography>
            </MKBox>
          </DialogContent>
        </Dialog>
      )}

      {/* Alert */}
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          zIndex: 9999, // 충분히 높은 값으로 설정
        }}
      >
        <Alert onClose={handleAlertClose} severity="info" sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </MKBox>
  );
}

export default License;
